import React from "react";
import { Box, Stack } from "@mui/material";
import { contentBoxStyle, greyBorderStyle } from "../shared/Theme";
import Sidebar from "../elements/Sidebar";
import Header from "../elements/Header";
import CardCriticalRisk from "../elements/Dashboard/CardCriticalRisks";
import CardCyberRiskExposure from "../elements/Dashboard/CardCyberRiskExposure";
import CardDarkWebExposure from "../elements/Dashboard/CardDarkWebExposure";
import CardCymplifyLogo from "../elements/Dashboard/CardCymplifyLogo";
import CardCyberAwareness from "../elements/Dashboard/CardCyberAwareness";
import CardComplianceHub from "../elements/Dashboard/CardComplianceHub";
import CardVulnerabilityScanReports from "../elements/Dashboard/CardVulnerabilityScanReports";

const Dashboard = () => {
	
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar/>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Header pageTitle="Dashboard"/>
				<Box sx={contentBoxStyle}>
					<Stack direction="column" sx={{ width: "80%", margin: "auto" }}>
						<Stack direction="row" justifyContent="center" sx={{
							borderBottom: "2px solid",
							...greyBorderStyle
						}}>
							<CardCyberRiskExposure/>
							<CardCriticalRisk/>
						</Stack>
						<Stack direction="row" justifyContent="center" sx={{
							borderBottom: "2px solid",
							...greyBorderStyle
						}}>
							<CardDarkWebExposure/>
							<CardCymplifyLogo/>
							<CardVulnerabilityScanReports/>
						</Stack>
						<Stack direction="row" justifyContent="center">
							<CardCyberAwareness/>
							<CardComplianceHub/>
						</Stack>
					</Stack>
				</Box>
			</Box>
		</Box>
	);
	
}

export default Dashboard;

